// CardPayment uses a debounce to prevent unnecessary reRenders.
export const DEBOUNCE_TIME_RENDER = 200; //ms
